export function toKatakanaCharCode(char: number): number {
  return char + 96
}
